// UserDashboard.js
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Card, Table } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import {formatDate} from "../../utils/helper";

const DashboardPage = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [stats, setStats] = useState([]);
  const [isLoader, setIsLoader] = useState([]);
  const [user_package, setUserPackage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getDashboard();
  }, []);

  const getDashboard = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: `getDashboard`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setStats(data.data.stats);
        setUserPackage(data.data.package);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

  return (
    <div>
      <div className="dashboard rounded d-flex p-3">
        <div className="dashboard-head-img border">
          <img src={user.picture} alt="pic" className="object-cover" />
        </div>
        <div className="img-txt">
          <h4 className="mx-3 mt-3">
            {user.username}
          </h4>
          <h6 className="mx-3">
            Email:
            <span className="fw-lighter mx-2">{user.email}</span>
          </h6>
        </div>
      </div>
      <div>
        <div className="sec-ii mt-3">
          <div className="sec-ii-icons d-flex flex-wrap justify-content-center">
            <div className="icon-i rounded col-12 col-md-3 col-lg-3 mb-3">
              <i className="bi bi-card-list"></i>
              <h5 className="mt-3 text-center">
                <span className="fw-normal mx-2 fs-6">Total Tests <b>{stats["total_tests"]}</b></span>
                
              </h5>
            </div>

            <div className="icon-i icon-ii rounded col-12 col-md-3 col-lg-3 mb-3">
              <i className="bi bi-megaphone-fill"></i>
              <h5 className="mt-3 text-center">
                <span className="fw-normal mx-2 fs-6">Available Courses <b>{stats["available_interviews"]}</b></span>
              </h5>
            </div>

            <div className="icon-i icon-iii rounded col-12 col-md-3 col-lg-3 mb-3">
              <i className="bi bi-hourglass-split"></i>
              <h5 className="mt-3 text-center">
                <span className="fw-normal mx-2 fs-6">Pending Tests <b>{stats["pending_tests"]}</b></span>
              </h5>
            </div>

            <div className="icon-i icon-iv rounded col-12 col-md-3 col-lg-3 mb-3">
              <i className="bi bi-exclamation-triangle"></i>
              <h5 className="mt-3 text-center">
                <span className="fw-normal mx-2 fs-6">Expired Courses <b>{stats["expired_interviews"]}</b></span>
              </h5>
            </div>
          </div>
        </div>
      </div>

      <Card className="p-2 mt-3 card-main">
        <Card.Body>
          <Card.Title className="border-bottom pb-3">Membership Report </Card.Title>
          {!isLoader && 
          <div>
            {user_package ? (
              <div className="mb-3">
                <h4>{user_package.package.name}</h4>
                <p className="fw-lighter">
                  <span className="fw-normal ">Status: <span  className={user_package.status=="Active"?"badge bg-success mx-2":"badge bg-danger mx-2"}>{user_package.status}</span> </span>
                </p>
                <p className="fw-lighter">
                  <span className="fw-normal">Valid Until:</span>
                  <span className="fw-semibold mx-2">{formatDate(user_package.expiry_date,'DD MMM YYYY, hh:mm A')} </span> 
                </p>
              </div>
            ) : (
              <div className="mb-3 alert alert-danger fs-6 fw-semibold">
                You don't have purchased any subscription
              </div>
            )}

            <p>
              Buy Membership <NavLink to="/packages">here</NavLink>.
            </p>
          </div>
          }
        </Card.Body>
      </Card>
    </div>
  );
};

export default DashboardPage;
